import { fromQueryString } from './fromQueryString';

export default function getQueryParamsFromLocation(location) {
  const query = location?.search?.substring(1);
  return query ? fromQueryString(query) : {};
}
